module.exports = __webpack_public_path__ + "img/20231204155839278fjs.8bec60b3.jpg";